/**
 * EmptyState — centered icon + message + optional actions.
 *
 * Props:
 *   icon     ReactNode  — icon element (e.g. <CalendarDays className="h-8 w-8 ..." />)
 *   message  string     — primary message
 *   sub      string     — secondary / helper text
 *   children ReactNode  — optional action buttons
 */
export default function EmptyState({ icon, message, sub, children }) {
  return (
    <div className="py-8 flex flex-col items-center text-center">
      {icon}
      <p className="mt-3 text-sm font-medium">{message}</p>
      <p className="text-xs text-muted-foreground mt-1 max-w-xs">{sub}</p>
      {children}
    </div>
  );
}
